const activateBrowsePromotionsJs = '.activateBrowsePromotionsJs'
const resultsContainer = '#results-boxes'
const SaleContainer = '#salePopUp'

export default class ItemBack {
  constructor() {
    this.lastLocation = null
    this.isPromotions = $(activateBrowsePromotionsJs).length
    this.spService = this.isPromotions ? SP.browsePromotions : SP.searchresults
    window.onItemBoxClick = this.onItemBoxClick.bind(this)
    window.onPromotionClick = this.onPromotionClick.bind(this)

    $.subscribe('queryinit', () => this.init())
  }
  onInit() {}
  init() {
    this.backItemId = this.spService.query.scrollToItem
    const element = $(`[data-id="${this.backItemId}"]`)
    const hasScroll = element.length
    this.onInit(hasScroll)
    if (hasScroll) {
      const yOffset = -150

      // setTimeout(() => {
      const y =
        element[0].getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'auto' })
      // }, 100)

      // element[0].scrollIntoView()
      this.spService.itemScrolled = true
    }
    this.spService.removeScrollToItem()
  }
  // setItemBoxListener() {
  //   $('.item-box-link').click(() => {

  //   })
  // }
  saveLastLocation(id, page) {
    this.lastLocation = {
      id,
      page,
    }
  }
  setItemToScroll(id, page, callback) {
    this.spService.setItemToScroll(id, page)
    setTimeout(callback)
  }
  onItemBoxClick(id, page, event, callback) {
    const isItemBox = $(event.target).closest(resultsContainer).length
    const isSaleItem = $(event.target).closest(SaleContainer).length
    if (isItemBox) {
      this.setItemToScroll(id, page, callback)
    } else if (isSaleItem && this.lastLocation) {
      this.setItemToScroll(
        this.lastLocation.id,
        this.lastLocation.page,
        callback
      )
    } else {
      callback()
      return
    }
  }

  onPromotionClick(id, page) {
    this.saveLastLocation(id, page)
  }
}
